// extracted by mini-css-extract-plugin
export default {"root":"WalletTokenAssetChart_root__ina51","title":"WalletTokenAssetChart_title__Guk85","chart":"WalletTokenAssetChart_chart__xqdun","refresh":"WalletTokenAssetChart_refresh__NFK64"};